export class PackageGroup {
  /**
   * @param {Object} response
   * @param {String} response.id
   * @param {String} response.name
   */
  constructor(response) {
    this.id = response.id;
    this.name = response.name;
  }
}
